import { useQuery } from 'react-query';
import { getNeededPlugins } from '..';
export const useNeedetGetPlugins = () => useQuery('GetPluginDescriptionList', getNeededPlugins);
